import { render, staticRenderFns } from "./alipaysh.vue?vue&type=template&id=ff4f1ff6&scoped=true"
import script from "./alipaysh.vue?vue&type=script&lang=js"
export * from "./alipaysh.vue?vue&type=script&lang=js"
import style0 from "./alipaysh.vue?vue&type=style&index=0&id=ff4f1ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4f1ff6",
  null
  
)

export default component.exports